import Api from '../../../common/services/api';

export const NETWORK_RECEIVE_FUNCTIONS = 'network/RECEIVE_FUNCTIONS';

export default () => async (dispatch, getState) => {
  const { network: { selected } } = getState();

  if (!selected) return null;

  const networkId = selected;

  const { data: functions } = await Api.get(`/v2/networks/${networkId}/functions`);

  if (getState().network.selected !== networkId) return null;

  return dispatch({
    type: NETWORK_RECEIVE_FUNCTIONS,
    functions,
  });
};
